<template>
  <div id="FinancialNotification" class="container">
    <div style="background: white" class="position-relative p-4">
      <K2Row justify_content="center" class="position-relative p-4">
        <K2Heading type="h5" class-name="mb-0" color="black">FINANCE NOTIFICATION SETUP</K2Heading>
      </K2Row>
    </div>
    <div style="background: white" class="position-relative p-4">
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column prop="School" label="School">
          <template #default="scope">
            <k2-row
              ><k2-text fontSize="small">{{ scope.row.School }}</k2-text></k2-row
            >
            <k2-row>
              <el-tag size="small" effect="dark" type="info">
                {{ scope.row.SchoolEmail }}
              </el-tag>
            </k2-row>
          </template>
        </el-table-column>
        <el-table-column prop="EmailTo" label="EmailTo">
          <template #default="scope">
            <el-tag
              v-for="email in scope.row.EmailTo"
              :key="email"
              size="small"
              closable
              :disable-transitions="false"
              @close="handleClose(email, scope.row.EmailTo)"
              >{{ email }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-model="scope.row.inputValueEmailTo"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleInputConfirm(scope.row.EmailTo, scope.row.inputValueEmailTo, scope.$index)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="EmailCC" label="EmailCC">
          <template #default="scope">
            <el-tag
              v-for="email in scope.row.EmailCC"
              :key="email"
              size="small"
              closable
              :disable-transitions="false"
              @close="handleClose(email, scope.row.EmailCC)"
              >{{ email }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-model="scope.row.inputValueEmailCC"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleInputConfirm(scope.row.EmailCC, scope.row.inputValueEmailCC)"
            />
          </template>
        </el-table-column>
        <el-table-column prop="EmailBCC" label="EmailBCC">
          <template #default="scope">
            <el-tag
              v-for="email in scope.row.EmailBCC"
              :key="email"
              size="small"
              closable
              :disable-transitions="false"
              @close="handleClose(email, scope.row.EmailBCC)"
              >{{ email }}</el-tag
            >
            <el-input
              class="input-new-tag"
              v-model="scope.row.inputValueEmailBCC"
              ref="saveTagInput"
              size="mini"
              @keyup.enter.native="handleInputConfirm(scope.row.EmailBCC, scope.row.inputValueEmailBCC)"
            />
          </template>
        </el-table-column>
        <el-table-column width="100">
          <template #default="scope">
            <el-button size="small" type="success" @click="handleSave(scope.row, scope.$index)"> Save </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import K2Button from '@/uiComponents/k2Button/k2Button'
import K2Heading from '@/uiComponents/k2Heading/k2Heading'
import K2Row from '@/uiComponents/k2Row/k2Row'
import K2Filter from '@/uiComponents/k2Filter/k2Filter'
import K2Text from '../../uiComponents/k2Text/k2Text'
import uiVariable from '@/config/uiVariable'
import { lang } from '@/locale'
import DataSource from '@/data/datasource'

export default {
  name: 'FinanceNotification',

  components: { K2Button, K2Heading, K2Row, K2Text, K2Filter },

  data() {
    return {
      uiVariable: uiVariable,
      selectedTab: 0,
      filterList: [
        {
          label: 'Schools',
          placeholder: 'Filter by Schools',
          optionList: [],
        },
      ],
      selectedSchool: null,

      tableData: [],
    }
  },

  mounted() {
    this.init()
  },

  methods: {
    lang,

    async init() {
      await this.getSchools()
      await this.loadReport()
    },

    onFilterChange(value) {
      this.getClass(value)
    },

    handleFilter(type) {
      if (this.filterList[0].selected !== undefined) {
        this.selectedSchool = this.filterList[0].selected.toString()
      }

      this.loadReport()
    },

    async getSchools() {
      const response = await DataSource.shared.getSchoolDropdownList('UTY201300000061')
      if (response) {
        response.Table.forEach(d => {
          d.id = d.SchoolID
          d.label = d.SchoolName
          d.type = 'school'
        })
      }
      this.filterList[0].optionList = response.Table
    },

    async loadReport() {
      // this.$vs.loading();
      this.filterList[0].optionList.forEach(i => {
        // console.log(i.SchoolID)
        this.loadSchoolReport(i.SchoolID, i.SchoolName)
      })

      // this.$vs.loading.close();
    },

    async loadSchoolReport(schId, schName) {
      try {
        const result = await DataSource.shared.GetFinanceNotificationEmailList(schId, schName)
        if (result.EmailTo != null) {
          let EmailTo = []
          let EmailCC = []
          let EmailBCC = []

          if (result.EmailTo !== '') {
            EmailTo = result.EmailTo.split(',')
          }
          if (result.EmailCC !== '') {
            EmailCC = result.EmailCC.split(',')
          }
          if (result.EmailBCC !== '') {
            EmailBCC = result.EmailBCC.split(',')
          }
          let schoolEmailList = {
            School: schName,
            SchoolId: result.SchoolId,
            SchoolEmail: result.SchoolEmail,
            EmailTo: EmailTo,
            EmailCC: EmailCC,
            EmailBCC: EmailBCC,
            inputValueEmailTo: '',
            inputValueEmailCC: '',
            inputValueEmailBCC: '',
          }

          this.tableData.push(schoolEmailList)
        }
      } catch (e) {
        console.log('get report err', e)
      }
    },
    handleClose(tag, array) {
      array.splice(array.indexOf(tag), 1)
    },

    handleInputConfirm(array, inputValue, index) {
      if (inputValue) {
        array.push(inputValue)
      }
      this.inputVisible = false
      inputValue = ''
    },

    async handleSave(row) {
      let EmailTo = row.EmailTo.join(',')
      let EmailCC = row.EmailCC.join(',')
      let EmailBCC = row.EmailBCC.join(',')
      const result = await DataSource.shared.SaveFinanceNotificationEmailList(row.SchoolId, EmailTo, EmailCC, EmailBCC)
      console.log(result.code)
      if (result.code === '1') {
        this.$notify.success({
          title: lang('Success'),
          message: lang('Save successful'),
        })
      } else {
        this.$notify.error({
          title: lang('Error'),
          message: lang('Save failed! Please try again later'),
        })
      }
    },
  },
}
</script>

<style scoped></style>
